
import React from 'react';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=cutting-edge%20environmental%20technology%20background%20with%20AI-powered%20carbon%20monitoring%20systems%2C%20smart%20sensors%20network%2C%20holographic%20environmental%20data%20visualization%2C%20futuristic%20green%20technology%20interface%20with%20neural%20networks%2C%20sustainable%20tech%20innovation%20lab%20environment%2C%20advanced%20carbon%20capture%20technology%20displays%2C%20digital%20twin%20environmental%20modeling%2C%20clean%20energy%20quantum%20computing%20systems&width=1920&height=1080&seq=hero-eco-tech-bg-002&orientation=landscape)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/70 to-transparent"></div>
      </div>

      {/* Floating Tech Elements */}
      <div className="absolute inset-0 z-5 pointer-events-none overflow-hidden">
        <div className="absolute top-20 left-20 w-2 h-2 bg-emerald-400 rounded-full animate-pulse opacity-60"></div>
        <div className="absolute top-40 right-32 w-1 h-1 bg-blue-400 rounded-full animate-ping opacity-40"></div>
        <div className="absolute bottom-32 left-1/4 w-3 h-3 bg-green-400 rounded-full animate-bounce opacity-50"></div>
        <div className="absolute top-1/3 right-20 w-1.5 h-1.5 bg-cyan-400 rounded-full animate-pulse opacity-70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <div className="mb-6 flex items-center gap-4">
              <span className="inline-block px-4 py-2 bg-emerald-600/20 text-emerald-400 rounded-full text-sm font-medium backdrop-blur-sm border border-emerald-500/30">
                <i className="ri-cpu-line mr-2"></i>
                AI驱动的低碳科技
              </span>
              <span className="inline-block px-4 py-2 bg-blue-600/20 text-blue-400 rounded-full text-sm font-medium backdrop-blur-sm border border-blue-500/30">
                <i className="ri-earth-line mr-2"></i>
                碳中和先锋
              </span>
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight mb-6">
              <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
                智慧环保
              </span>
              <br />
              <span className="text-white">科技</span>
              <span className="text-emerald-400">碳未来</span>
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed mb-8 max-w-2xl">
              融合人工智能、物联网和区块链技术，构建下一代智能碳管理生态系统。通过前沿科技赋能环保事业，实现精准碳排放监测、智能减排优化和可持续发展目标。
            </p>
            
            {/* Tech Features */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="flex items-center text-sm text-gray-300">
                <div className="w-8 h-8 bg-emerald-500/20 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-brain-line text-emerald-400"></i>
                </div>
                AI智能分析
              </div>
              <div className="flex items-center text-sm text-gray-300">
                <div className="w-8 h-8 bg-blue-500/20 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-sensor-line text-blue-400"></i>
                </div>
                IoT传感监控
              </div>
              <div className="flex items-center text-sm text-gray-300">
                <div className="w-8 h-8 bg-cyan-500/20 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-links-line text-cyan-400"></i>
                </div>
                区块链溯源
              </div>
              <div className="flex items-center text-sm text-gray-300">
                <div className="w-8 h-8 bg-green-500/20 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-leaf-line text-green-400"></i>
                </div>
                零碳目标
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-12">
              <button 
                onClick={scrollToContact}
                className="px-8 py-4 bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700 text-white font-semibold rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                <i className="ri-rocket-line mr-2"></i>
                开启智能碳管理
              </button>
              <button 
                onClick={scrollToContact}
                className="px-8 py-4 border-2 border-emerald-400 text-emerald-400 hover:bg-emerald-400 hover:text-gray-900 font-semibold rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm"
              >
                <i className="ri-play-line mr-2"></i>
                探索科技方案
              </button>
            </div>
            
            {/* Enhanced Stats */}
            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-gray-700">
              <div className="text-center">
                <div className="text-3xl font-bold bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">300+</div>
                <div className="text-gray-400 text-sm">AI赋能企业</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold bg-gradient-to-r from-blue-400 to-green-400 bg-clip-text text-transparent">800+万吨</div>
                <div className="text-gray-400 text-sm">智能碳资产管理</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">400+万吨</div>
                <div className="text-gray-400 text-sm">科技减排成果</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Animated Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <div className="flex flex-col items-center">
          <i className="ri-arrow-down-line text-2xl mb-2"></i>
          <div className="text-xs text-gray-400">探索更多</div>
        </div>
      </div>
    </section>
  );
}